import * as actions from "../../../actions/tagColor/edit";

const initialTagColorState = {
  name: "",
  hexCode: "",
  active: true
};

const initialState = {
  loading: false,
  item: null,
  errors: {},
  ...initialTagColorState
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    case actions.CLEAR_VALUE: {
      const { item } = state;

      return {
        ...state,
        ...initialTagColorState,
        item,
        name: item ? item.name : "",
        hexCode: item ? item.hexCode : "",
        active: item ? item.active : true
      };
    }
    case actions.GET_TAG_COLOR: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.EDIT_TAG_COLOR: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_TAG_COLOR_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.EDIT_TAG_COLOR_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.EDIT_TAG_COLOR_SUCCESS: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_TAG_COLOR_SUCCESS: {
      return {
        ...state,
        item: payload,
        name: payload.name,
        hexCode: payload.hexCode,
        active: payload.active,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
